<div class="main-contents">
    <div class="webslider">    
        <owl-carousel-o [options]="customOptions">
            <ng-template carouselSlide>
                <div class="slide">
                    <img src="../../assets/images/websites/web-slider-01.jpg">
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="slide">
                    <img src="../../assets/images/websites/web-slider-02.jpg">
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="slide">
                    <img src="../../assets/images/websites/web-slider-03.jpg">
                </div>
            </ng-template>   
            <ng-template carouselSlide>
                <div class="slide">
                    <img src="../../assets/images/websites/web-slider-04.jpg">
                </div>
            </ng-template>
            <ng-template carouselSlide>
                <div class="slide">
                    <img src="../../assets/images/websites/web-slider-05.jpg">
                </div>
            </ng-template>   
        </owl-carousel-o>
    </div>
    <div class="register-form padding-top-30">
        <div class="container">
            <h2 class="text-center padding-bottom-15">Registration</h2>
            <div class="row">        
                <div class="col-md-6 padding-bottom-30">
                    <div class="alert alert-success" *ngIf="isUserLogin">                        
                        You are already logged in.
                    </div>
                    <div class="" *ngIf="!isUserLogin">
                        <form [formGroup]="registerForm" (ngSubmit)="postdata(registerForm)" autocomplete="off" >
                            <div class="form-group">
                                <label for="name">Name</label>
                                <input type="text" name="name" formControlName="name" autocomplete="off" class="form-control input-sm" placeholder="Name">
                            </div>
                            <div class="alert alert-danger" *ngIf="registerForm.get('name').hasError('required') && registerForm.get('name').touched">
                                Please enter your name.
                            </div>
                            <div class="form-group">
                                <label for="email">Email</label>
                                <input type="email" name="email" formControlName="email" autocomplete="off" class="form-control input-sm" placeholder="Email">
                            </div>
                            <div class="alert alert-danger" *ngIf="registerForm.get('email').hasError('required') && registerForm.get('email').touched">
                                Please enter email.
                            </div>
                            <div class="alert alert-danger" *ngIf="registerForm.get('email').hasError('maxlength') && registerForm.get('email').touched">
                                Maximum 30 characters are allowed.
                            </div>
                            <div class="alert alert-danger" *ngIf="registerForm.get('email').hasError('pattern') && registerForm.get('email').touched">
                              Please enter the correct email format.
                            </div>
                            <div class="form-group">
                                <label for="Password">Password</label>
                                <input type="password" name="Password" formControlName="password" autocomplete="off" class="form-control input-sm" placeholder="Password">
                            </div>
                            <div class="alert alert-danger" *ngIf="registerForm.get('password').hasError('required') && registerForm.get('password').touched">
                                Please enter password.
                            </div>
                            <div class="alert alert-danger" *ngIf="registerForm.get('password').hasError('minLength') && registerForm.get('password').touched">
                                Minimum 8 characters are allowed.
                            </div>
                            <button type="submit" class="btn btn-success" >Register</button>
                        </form>
                    </div>
                </div>
                <div class="col-md-6 social-media padding-bottom-30">
                    <instagram-post></instagram-post>
                    <tumblr-posts></tumblr-posts>
                </div>
            </div>
        </div>
    </div>
</div>
